module.exports = __webpack_public_path__ + "static/img/question.5996679e.png";